// extracted by mini-css-extract-plugin
export default {"container":"BasketPage_container__8lrIR","location_container":"BasketPage_location_container__RDbtp","location_title":"BasketPage_location_title__XsqFj"};